import { z } from 'zod'
import { oc } from '@orpc/contract'
import { scribeSourceLanguageSchema } from './encounter-language.contract'

export const startSessionResponseSchema = z.object({
  sessionId: z.string(),
  encounterId: z.string(),
  startedAt: z.string(),
  /** The session's language — an adopted live session keeps the one it was started with. */
  language: scribeSourceLanguageSchema,
})
export type StartSessionResponse = z.infer<typeof startSessionResponseSchema>

export const scribeStartSession = oc
  .route({ method: 'POST', path: '/v2/scribe/sessions/{encounterId}/start' })
  .input(z.object({ encounterId: z.string(), language: scribeSourceLanguageSchema.optional() }))
  .output(startSessionResponseSchema)
